import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FunctionsService } from 'src/app/___LOGIC/__common/functions.service';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';
import { EditContractModalComponent } from 'src/app/___COMPONENTS/edit-contract-modal/edit-contract-modal.component';

@Component({
  selector: 'app-omnibus-clients',
  templateUrl: './omnibus-clients.component.html',
  styleUrls: ['./omnibus-clients.component.css']
})
export class OmnibusClientsComponent implements OnInit {

  omnibusContracts = [];
  selectedContract: any;
  loading = false;
  studentInfo;

  constructor(private resolver: ResolverService,private commonFunctions: FunctionsService,private http: HttpClient,private dialog: MatDialog) {
    /* this.resolver.getBackendDataForQueryId('getOmnibusContracts',true,null); */
    this.loadContracts();
  }

  ngOnInit(): void {
  }

  getProcessStatus(status){
    switch(status){
      case '0':
        return 'No comenzado';
      case '1':
        return 'Detalles seguro y estudios';
      case '2':
        return 'Datos personales';
      case '3':
        return 'Subir docs';
      case '4':
        return 'Generarando docs seguro';
      case '5':
        return 'Rellenar/firmar docs';
      case '6':
          return 'Subir docs firmados';
      case '7':
        return 'Aprobación ASISA';
      case '8':
        return 'Esperando pago cliente';
      case '9':
        return 'Esperando comprobante PDF';
    }
  }

  getOmnibusClients(){
    return this.omnibusContracts;
    /* return this.resolver.resolveList('getOmnibusContracts'); */
  }

  getMonthsRemaining(d1,d2){
    return this.commonFunctions.getMonthsRemaining(d1,d2);
  }

  getOmnibusTotalComissions(){
    /* let total = 0;
    for(let c of this.contractList){
      total+= (c.price*0.1);
    }
    return total.toFixed(2); */
  } 

  getVJTotalComissions(){
/*     let total = 0;
    for(let c of this.contractList){
      total+= (c.price*0.1)*0.30;
    }
    return total.toFixed(2); */
  }

  editContract(contract){
    this.http.get('https://app.voyjaleas.com/myapp/get/queryHandler.php?queryId=getStudentInfo&queryParam1='+contract.id)
      .subscribe(
        (response) => {
          this.studentInfo = response['records'];
          this.openEditModal(contract);
        },
        (error) => {
          console.log(error);
        }
    );
  }

  openEditModal(contract: any): void {
    const dialogRef = this.dialog.open(EditContractModalComponent, {
      width: '400px',
      data: { 
        contract: contract,
        studentInfo: this.studentInfo
       }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadContracts();
      /* if (result === 'updated') {
        this.loadContracts(); // recarga datos si se actualizó
      } */
    });
  }

  loadContracts() {
    this.loading = true;
    // tu lógica para cargar contratos
    this.http.get('https://dashboard.voyjaleas.com/api-dashboard/get/queryHandler.php?queryId=getAllClientOmnibusContracts')
        .subscribe(
          (response) => {
            this.omnibusContracts = response['data'];
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            console.log(error);
          }
      )
  }
  

}
